<template>
  <div>
    <div class="row">
      <app-overlay-loader v-if="preloader" />
      <div class="col-12">
        <legend class="text-primary">
          <small> Datos del gestor </small>
        </legend>
      </div>
      <div class="col-12">
        <div class="form-group">
          <label>Seleccione gestor técnico del expediente</label>
          <app-input
            type="select"
            v-model="inputs.responsible_technician"
            :list="[{ id: '', value: this.$t('select_option') }, ...gestorList]"
            :required="true"
          />
        </div>
      </div>
      <div class="col-12">
        <legend class="text-primary">
          <small> Datos de la resolución </small>
        </legend>
      </div>
      <!-- <div class="col-12 col-sm-6">
        <div class="form-group">
          <label>Resolución número <b class="text-danger">*</b></label>
          <app-input
            type="text"
            v-model="inputs.resolution_number"
            :required="true"
          />
        </div>
      </div> -->
      <div class="col-12 col-sm-6">
        <div class="form-group">
          <label
            >Fecha de Acreditación Inicial
            <b class="text-danger">*</b></label
          >
          <app-input
            type="date"
            v-model="inputs.resolution_date"
            :required="true"
          />
        </div>
      </div>
      <!-- <div class="col-12 col-sm-6">
        <div class="form-group">
          <label>Número de certificado <b class="text-danger">*</b></label>
          <app-input
              type="text"
              v-model="inputs.certificate_number"
              :required="true"
          />
        </div>
      </div> -->
      <div class="col-12 col-sm-6">
        <div class="form-group">
          <label>Acreditación número<b class="text-danger">*</b></label>
          <app-input
              type="text"
              v-model="inputs.acc_number"
              :required="true"
          />
        </div>
      </div> 

      <div class="col-12 mt-3">
        <button type="button" class="btn btn-primary" @click.prevent="submit">
          Guardar
        </button>
      </div>
    </div>
    <br />
    <hr />
    <div class="row">
      <div class="col-12">
        <legend>
          <small class="text-primary"
            >Resoluciones vigentes</small
          >
        </legend>
      </div>
      <div class="col-sm-12 col-md-12">
        <div class="row">
          <div class="col-12">
            <div class="row mb-2" v-for="(vj, j) in additional_605" :key="j">
              <div class="col-12 col-md-5" v-if="!vj.annexed">
                <app-input
                  :id="`file_${j}`"
                  type="file"
                  :label="vj.file ? vj.file.name : $t('upload_your_file')"
                  v-model="vj.file"
                  @change="onChange($event, j)"
                />
                <small v-if="!vj.annexed" class="text-center text-danger"
                  >Tamaño máximo del archivo 8 Mb</small
                >
              </div>

              <div class="col-12 col-md-6" v-if="vj.annexed">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openFileTab(vj.annexed)"
                >
                  <app-icon name="file" /> Ver
                </button>

                <button
                  type="submit"
                  class="btn btn-danger"
                  @click.prevent="openDeleteModal(j, vj)"
                >
                  <app-icon name="trash-2" /> Eliminar
                </button>
              </div>

              <div class="col-12 col-md-5" v-if="vj.annexed">
                <app-input
                  :id="`filename_${j}`"
                  type="text"
                  v-model="vj.filename"
                  placeholder="Descripcion del archivo"
                  @keyup="onKeyUp(j)"
                />
                <small v-if="!vj.filename" class="text-center text-danger"
                  >Es necesario agregar una descripción</small
                >
              </div>
              <div class="col-12 col-md-2 text-center" v-if="!vj.annexed">
                <button
                  type="submit"
                  class="btn btn-warning"
                  @click="removeRowFile(j)"
                  v-if="!vj.annexed"
                >
                  Quitar
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <button
                  type="submit"
                  class="btn btn-primary"
                  @click="addFile()"
                >
                  <app-icon name="plus" /> Agregar archivo
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="confirm"
      @cancelled="cancelled"
    />
  </div>
</template>
<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
// import * as actions from "../../../../apiURL";
import { axiosPost } from "@/app/helpers/AxiosHelper";
import { axiosDelete } from "../../../../../../../../../resources/js/app/helpers/AxiosHelper";
export default {
  extends: CoreLibrary,
  mixins: [FormMixin],
  data() {
    return {
      selectedUrl: "",
      isAddEditModalActive: false,
      preloader: false,
      inputs: {},
      docs: "",
      observation: "",
      deleteModal: false,
      selected: "",
      evaluations: [],
      additional_605: [],
      gestorList: [],
    };
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },

  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview.evalTest
        ? this.$store.state.evaluatorReview.evalTest
        : {};
    },
    accApp() {
      return this.evalTest ? this.evalTest.accreditation_applications : null;
    },
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },
  watch: {
    "$store.state.evaluatorReview.evalTest": function () {
      this.loadForm();
    },
  },

  created() {
    // console.log(this.$store.state.accreditation.id);
    this.dataInfo();
    // this.dataList();
  },

  methods: {
    addFile() {
      if (this.additional_605.length >= 100) {
        this.$toastr.e("Solo se pueden adjuntar un maximo de 100 archivos");
        return;
      }
      this.additional_605.push({
        record_id: this.$store.state.accreditation.id,
        filename: null,
        file: null,
      });
    },

    openFileTab(file) {
      const w = window.open(file.path, "_blank");
      w.focus();
    },

    openDeleteModal(j, vj) {
      this.deleteModal = true;
      this.tmp = {
        j: j,
        vj: vj,
      };
    },

    removeRowFile(j) {
      this.additional_605 = this.additional_605.filter(
        (value, index) => index != j
      );
    },

    cancelled() {
      this.deleteModal = false;
    },

    onChange(e, j) {
      const tmp = this.additional_605[j];
      if (!tmp.file) return;

      if (tmp.file.size > 8700000) {
        this.$set(this.additional_605[j], "file", null);
        this.$set(this.additional_605[j], "filename", null);
        this.$toastr.e("El tamaño maximo permitido por archivo es de 8MB");
        return;
      }
      if (!tmp.filename) this.$set(this.additional_605[j], "filename", "");
      this.chargeFile(j);
    },

    onKeyUp(j) {
      const tmp = this.additional_605[j];
      if (!tmp.annexed) {
      } else {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => this.chargeFile(j), 1000);
      }
    },

    removeRowFile(j) {
      this.additional_605 = this.additional_605.filter(
        (value, index) => index != j
      );
    },

    chargeFile(j) {
      this.deleteLoader = true;
      const url = `/evaluator/decision/closureFindingsDecision/addFileAttach`;
      const tmpo = this.additional_605[j];
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.additional_605[j])) {
        formData.append(key, value);
      }
      axiosPost(url, formData)
        .then((res) => {
          this.deleteLoader = false;
          if (tmpo.file) {
            const data = res.data.data[res.data.data.length - 1];
            const tmp = [...this.additional_605];
            tmp[j] = data;
            this.additional_605 = tmp;
          }
        })
        .catch(({ error }) => {});
    },

    confirm() {
      const url = `/evaluator/decision/closureFindingsDecision/destroyFileAttach?eval_annexed_id=${this.tmp.vj.record_id}&id=${this.tmp.vj.id}&type=${this.tmp.vj.type}`;
      axiosDelete(url)
        .then((res) => {
          this.deleteModal = false;
          this.deleteLoader = false;
          const { data } = res.data.data;
          if (this.tmp.vj.type == "additional_605") {
            const tmp = this.additional_605.filter(
              (value, index) => index != this.tmp.j
            );
            this.additional_605 = tmp;
          }
        })
        .catch(({ error }) => {});
    },

    dataInfo() {
      let url = `/accreditationReview/decision/areaDirectorReport/show?accAppId=${this.$store.state.accreditation.id}`;
      this.axiosGet(url).then((response) => {
        this.inputs = response.data;
        this.docs = response.data;
        this.additional_605 = response.data.additional_605;

        if(response.data.resolution_date) {
          let date = new Date(response.data.resolution_date);
          date.setDate(date.getDate() + 1);
          this.inputs.resolution_date = date;
        } else {
          this.inputs.resolution_date = new Date();
        }
      });

      let urlGestorList = "/tecnicos";
      this.axiosGet(urlGestorList).then((response) => {
        this.gestorList = response.data.tecnics;
      });
    },
    /*dataList() {
      let url = `${actions.TECHNICAL_ANALYSIS_REPORT}/decisionDirectorFile/directorTechnicalReport/evaluationList/${this.$store.state.evaluatorReview.evalTestId}`;
      this.axiosGet(url).then((response) => {
        this.evaluations = response.data.evaluations;
      });
    }, */

    openModal(evaluation) {
      this.$store.state.qualityManagement.evaluation = evaluation;
      this.openAddEditModal();
    },

    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    closeAddEditModal() {
      $("#director-area-modal").modal("hide");
      this.isAddEditModalActive = false;
      // this.reSetData();
    },

    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },

    openTabFor(path) {
      const w = window.open(path, "_blank");
      w.focus();
    },

    submit() {
      this.preloader = true;
      var datos = this.inputs;
      const url = `accreditations/applications_historical_data/saveGestor`;
      axiosPost(url, datos).then((res) => {
        this.preloader = false;
        this.$toastr.s(this.$t("updated_success"));
      });
    },

    afterSuccess({ data: { data } }) {
      this.preloader = false;
      this.$store.state.evaluatorReview.evalTest = data;
      this.$toastr.s(this.$t("updated_success"));
    },

    // openDeleteModal(fileName) {
    //   this.selected = fileName;
    //   this.deleteModal = true;
    // },

    confirmed(fileName) {
      this.inputs[fileName] = null;
    },

    cancelled() {
      this.deleteModal = false;
    },

    loadForm() {
      if (this.$store.state.evaluatorReview.evalTest) {
        this.inputs = {
          id: this.$store.state.evaluatorReview.evalTest.id,
          evidence_member_participation:
            this.$store.state.evaluatorReview.evalTest
              .evidence_member_participation,
          technical_file_analysis_report:
            this.$store.state.evaluatorReview.evalTest
              .technical_file_analysis_report,
          maintenance_plan:
            this.$store.state.evaluatorReview.evalTest.maintenance_plan,
          director_technical_report:
            this.$store.state.evaluatorReview.evalTest
              .director_technical_report,
          scope605: this.$store.state.evaluatorReview.evalTest.scope605,
        };
      }
    },
  },
};
</script>
